<template>
  <div class="lay-header">
    <div class="lay-header-logo">
      <img src="@/assets/images/aqt-logo3.png" style="height: 100%">
    </div>

    <div class="lay-header-user">
      <h3 class="username">{{ userData.username ? userData.username : (userData.tel?$getNumberEncrypt(userData.tel):'') }}</h3>
      <Dropdown placement="bottom-end" @on-click="userClick" style="height: 100%;">
        <div class="spam">
          <Icon type="ios-arrow-down" color="#fff" size="20"></Icon>
        </div>
        <DropdownMenu slot="list">
          <DropdownItem :name="1">个人信息</DropdownItem>
          <DropdownItem :name="2">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>

    <aqt-sidebar v-model="show" :title="titles" slot="others" :transfer="true">
      <component :is="'Operation'" ></component>
    </aqt-sidebar>
  </div>
</template>

<script>
export default {
  components: {
    Operation: resolve => {require(['@/views/UserInformation/Index.vue'], resolve);},
  },
  data() {
    return {
      userData: {},
      src: 'http://oaapi.aqitai.com/uploads/20240918/d1c99b09fd9147958759534a66a1fba6.png',

      show: false,
      titles: '',
    }
  },

  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },

  mounted() {
    this.userData = JSON.parse(this.userInfo)
  },

  watch: {
    userInfo: {
      handler(val, oldValue) {
        this.userData = val?JSON.parse(val):''
      },
      deep: true
    }
  },

  methods: {

    /*****************************************************************
     *
     * 路由处理
     * @param   {name}             value
     *
     *****************************************************************/
    userClick(name) {
      switch (name) {
        case 1:
            this.titles = '个人信息'
            this.show = true
          break;
        case 2:
          // this.$store.dispatch('saveUserBehavior', {
          //   path: this.$route.path,
          //   name: '点击退出登录按钮',
          //   other_id: '',
          //   type: '',
          // }).then(() => {})

         this.$clearLocalStorageExceptActivePages()
          sessionStorage.clear()
          this.$store.state.tabList = '[]'
          this.$store.state.userInfo = ''
          if(this.$route.query.lib){
            this.$router.push({
              path:'/login',
              query:{
                lib:this.$route.query.lib,
                alis:this.$route.query.alis
              }
            })
          }else{
            this.$router.push('/login')
          }

          break;
      }
    }
  }
};
</script>

<style lang="less">
.lay-header {
  height: 70px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  &-logo {
    width: auto;
    padding: 8px 12px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    cursor: pointer;
  }

  &-user {
    width: auto;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding-right: 40px;

    .spam {
      height: 100%;
      margin-left: 10px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .username {
      margin-left: 10px;
      color: #fff;
    }

    .ivu-dropdown {
      height: 100%;

      .ivu-dropdown-rel {
        height: 100%;
      }
    }
  }
}
</style>
